import store from '../../redux/store';
import {
  setEmptyDependents,
  setOtherDefaults,
  setProspectDetails,
} from '../../redux/slices/quoteDataSlice';
import { setQuoteResponse } from '../../redux/slices/quoteResponseSlice';
import {
  setAddChildren,
  setAddOthers,
  setAddSpouse,
  setIsValidPostcode,
} from '../../redux/slices/appStateSlice';
import lookupPostCode from './lookupPostCode';
import { setAddressResults } from '../../redux/slices/addressResultsSlice';
import { formatDateToString } from '../dateUtils/dateUtils';

const loadQuoteData = async data => {
  const prospectDetails = {
    ...data.prospectDetails,
    coverStartDate: formatDateToString(new Date(data.quoteDetails?.[0]?.coverStartDate)),
  };

  store.dispatch(setProspectDetails(prospectDetails));
  store.dispatch(setOtherDefaults());
  store.dispatch(setQuoteResponse(data));

  if (
    data.prospectDetails?.dependents?.spouse ||
    data.prospectDetails?.dependents?.children?.length
  ) {
    store.dispatch(setAddOthers('true'));
  } else {
    store.dispatch(setAddOthers('false'));
  }

  if (data.prospectDetails?.dependents?.spouse) {
    store.dispatch(setAddSpouse(true));
  }
  if (data.prospectDetails?.dependents?.children?.length) {
    store.dispatch(setAddChildren(true));
  }
  if (data.prospectDetails?.dependents === undefined) {
    store.dispatch(setEmptyDependents());
  }

  if (data.prospectDetails?.address?.postCode) {
    const postCode = data.prospectDetails?.address?.postCode;
    await lookupPostCode(postCode)
      .then(response => {
        if (!response.ok) {
          store.dispatch(setIsValidPostcode(false));
          throw new Error(`Postcode validation response not ok for postcode ${postCode}.`);
        }
        store.dispatch(setIsValidPostcode(true));
        return response.json();
      })
      .then(responseBody => {
        if (responseBody !== '{}') {
          store.dispatch(setAddressResults(responseBody));
        }
      });
  }
};

export default loadQuoteData;
